import { SectionStepProgressPipe } from './pipes/section-step-progress.pipe';
import { CurrentSectionPipe } from './pipes/section-name.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SectionDonePipe } from './pipes/section-done.pipe';
import { SectionProgressPipe } from './pipes/section-progress.pipe';
import { ScreenStepComponent } from './screen-step.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    ScreenStepComponent,
    SectionProgressPipe,
    SectionDonePipe,
    CurrentSectionPipe,
    SectionStepProgressPipe,
  ],
  exports:  [
    ScreenStepComponent,
  ],
})
export class ScreenStepModule { }
